// TODO: Colocated with custom-collections because custom-collections is the only consumer.
// Mirrors step-wrapper.tsx's two inline JSX branches for the beforeHooks
// loading spinner (`!beforeHooksLoaded && !beforeHooksError`) and the
// error fallback (`beforeHooksError`). Keep both in sync — if step-wrapper
// changes spinner styling, error copy defaults, or StepContentSection slot
// forwarding, apply the same change here. If a future refactor shares
// lifecycle between step-wrapper and custom-collections, relocate this up to
// `src/components/` and have step-wrapper consume it.
import { ReactNode } from "react";
import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { FinancialBrand, StepAssets } from "@dreambigger/shared/src/types";
import StepContentSection from "../../../components/StepContentSection";

/**
 * Renders the loading spinner or the configured error state while
 * `assets.beforeHooks.hooks` execute, and passes through to `children` once
 * they resolve successfully. Shared between StepWrapper (v1) and custom-collections
 * so the same beforeHooks UX applies to both step pipelines.
 */
export default function BeforeHooksGate({
  assets,
  brand,
  progress,
  loaded,
  error,
  children,
}: {
  assets: StepAssets;
  brand: FinancialBrand;
  progress: number;
  loaded: boolean;
  error: boolean;
  children: ReactNode;
}) {
  if (assets.beforeHooks && !loaded && !error) {
    return (
      <StepContentSection
        brand={brand}
        stepProgress={progress}
        title=""
        description=""
        previousSlug={assets.previousSlug}
        hideProgressBar={assets.hideProgressBar}
        heroImage={assets.heroImage}
        heroText={assets.heroText}
        heroLogo={assets.heroLogo}
      >
        <Spin indicator={<Loading3QuartersOutlined spin />} />
      </StepContentSection>
    );
  }

  if (error) {
    return (
      <StepContentSection
        brand={brand}
        stepProgress={progress}
        title={assets.beforeHooks?.errorTitle ?? "Error"}
        description={assets.beforeHooks?.errorDescription ?? ""}
        previousSlug={assets.previousSlug}
        hideProgressBar={assets.hideProgressBar}
        heroImage={assets.heroImage}
        heroText={assets.heroText}
        heroLogo={assets.heroLogo}
      >
        <div className="flex flex-column gray-8">
          <p className="f-3">
            {assets.beforeHooks?.errorText ||
              "There was an issue loading this application."}
          </p>
        </div>
      </StepContentSection>
    );
  }

  return <>{children}</>;
}
